import { lazy } from "react";
import { Navigate, useParams } from "react-router-dom";
import { getBlogRedirectTarget } from "@/lib/blogRedirects";

const BlogPost = lazy(() => import("@/pages/BlogPost"));

/**
 * Intercepts /blog/:slug before BlogPost renders (and before any database
 * lookup) so consolidated legacy posts redirect to their pillar guide.
 */
const BlogSlugRoute = () => {
  const { slug } = useParams<{ slug: string }>();
  const target = getBlogRedirectTarget(slug);

  if (target) {
    return <Navigate to={`/blog/${target}`} replace />;
  }

  return <BlogPost />;
};

export default BlogSlugRoute;
